"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledSystem = require("styled-system");
var _default = _styledSystem.space;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJzcGFjZSJdLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wR3JvdXBzL3NwYWNlLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHNwYWNlLCBTcGFjZVByb3BzIH0gZnJvbSAnc3R5bGVkLXN5c3RlbSc7XG5cbmV4cG9ydCB0eXBlIEN1c3RvbVNwYWNlUHJvcHMgPSBTcGFjZVByb3BzO1xuXG5leHBvcnQgZGVmYXVsdCBzcGFjZTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7QUFBa0QsZUFJbkNBLG1CQUFLO0FBQUEifQ==